import {
  cornermarkDetailsFragment,
  cornermarkFragment
} from "@saleor/fragments/cornermark";
import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import {
  CornermarkDetails,
  CornermarkDetailsVariables
} from "./types/CornermarkDetails";
import {
  CornermarkList,
  CornermarkListVariables
} from "./types/CornermarkList";

const cornermarkList = gql`
  ${cornermarkFragment}
  ${pageInfoFragment}
  query CornermarkList(
    $filter: CornerMarkFilterInput
    $before: String
    $after: String
    $first: Int
    $last: Int
    $sort: CornerMarkSortingInput
  ) {
    cornerMarks(
      filter: $filter
      before: $before
      after: $after
      first: $first
      last: $last
      sortBy: $sort
    ) {
      totalCount
      edges {
        node {
          ...CornermarkFragment
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
      totalCount
    }
  }
`;

export const useCornermarkListQuery = makeQuery<
  CornermarkList,
  CornermarkListVariables
>(cornermarkList);

const cornermarkDetails = gql`
  ${cornermarkDetailsFragment}
  query CornermarkDetails(
    $id: ID!
    $after: String
    $before: String
    $first: Int
    $last: Int
  ) {
    cornerMark(id: $id) {
      ...CornermarkDetailsFragment
    }
  }
`;
export const useCornermarkDetailsQuery = makeQuery<
  CornermarkDetails,
  CornermarkDetailsVariables
>(cornermarkDetails);
